import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/icon_comment.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a5355d76")

_pushScopeId("data-v-a5355d76")
const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = { class: "news-title" }
const _hoisted_4 = { class: "news-comment" }
const _hoisted_5 = {
  key: 0,
  class: "comment"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.slice(0,3), (item) => {
      return (_openBlock(), _createBlock("a", {
        href: _ctx.link(item),
        class: "item",
        key: item
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: item.img_url + '?imageMogr2/auto-orient/thumbnail/!252x189r/gravity/Center/crop/252x189|imageslim',
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(item.news_title) + " ", 1),
          _createVNode("div", _hoisted_4, [
            (item.reply_count)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("span", null, _toDisplayString(item.reply_count), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("span", null, _toDisplayString(_ctx.fmTime(item.happen_time)), 1)
          ])
        ])
      ], 8, ["href"]))
    }), 128))
  ]))
})